<script setup>
import { Document,CloseBold, RemoveFilled } from "@element-plus/icons-vue"

const props = defineProps([ 'filterData','removeFilter','id']);

const keyOptions = [
        {
            value: 'to_email', label: 'To', icon: ''
        },
        {
            value: 'subject', label: 'Subject', icon: ''
        },
        {
            value: 'message', label: 'Message', icon: ''
        },
];
const operatorOptions = [
        {
            value: '=', label: 'Equal', operator: '='
        },
        {
            value: '!=', label: 'Not Equal', operator: '!='
        },
        {
            value: 'LIKE', label: 'Contain', operator: 'LIKE'
        },
        {
            value: 'NOT LIKE', label: 'Not Contain', operator: 'NOT LIKE'
        }
];

</script>

<template>
    <div class="wml-filter-row">
        <el-row>
        <el-col :span="4">
        <el-select v-model="props.filterData.key" placeholder="Select">
            <el-option
            v-for="item in keyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            />
        </el-select>
        </el-col>
        <el-col :span="4">
        <el-select v-model="props.filterData.operator" placeholder="Select">
            <el-option
            v-for="item in operatorOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            />
        </el-select>
        </el-col>
        <el-col :span="4">
        <el-input class="wml-filter-value" placeholder="Enter Value" v-model="props.filterData.value" />
        </el-col>
        <el-col :span="8" class="wml-remove-filter">
            <el-icon class="el-icon--left" @click="(e) => removeFilter(e,props.id)" :id="props.id"><RemoveFilled /></el-icon>
        </el-col>
        </el-row>
    </div>
</template>